import { Link } from "react-router-dom";

/**
 * Reusable Logo component.
 * Uses the official RentAnything.ai wordmark (PNG) downloaded from the existing
 * site into /public/brand/rentanything-logo.png. Constrain by height, let the
 * width auto-scale to preserve the wordmark's natural aspect ratio (~5:1).
 *
 * Variants:
 *   - default (nav): height 32
 *   - footer:        height 28
 *   - hero:          height 40+
 */
export default function Logo({ className = "", to = "/", height = 32 }) {
  const inner = (
    <span className={`inline-flex items-center ${className}`} data-testid="ra-logo">
      <img
        src="/brand/rentanything-logo.png"
        alt="RentAnything.ai"
        height={height}
        style={{ height: `${height}px`, width: "auto" }}
        className="block select-none"
        draggable={false}
      />
    </span>
  );

  if (!to) return inner;
  return (
    <Link
      to={to}
      aria-label="RentAnything.ai home"
      className="inline-flex items-center rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ra-ocean"
    >
      {inner}
    </Link>
  );
}
